/* Copyright (c) 2017 Backpack Health LLC */

/* global window */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { selectors as groupSelectors } from '../../../../redux/ducks/group';
import * as selectors from '../../../redux/reduxSelectors';

import Spacer from '../../../../components/Spacer';
import { Heading } from '../../../../components/Text';
import { ClampedText } from '../../../../components/ClampedText';
import GroupMetadataModel from '../../../../../models/GroupMetadata';
import { GroupThemeMarkdown } from '../../../../components/Markdown';
import I18nText from '../../../../components/I18nTranslation';

function mapStateToProps(state) {
  return {
    getGroup: (groupId) => (new GroupMetadataModel(groupSelectors.getGroup(state, groupId))),
    preferredLanguage: selectors.getCurrentLocaleLanguageCode(state),
  };
}

const GroupAboutText = (props) => {
  const group = props.getGroup(props.groupId);
  const isWide = window.innerWidth >= 640;

  return (
    <div>
      {
        !props.noHeading && (
          <>
            <Heading>
              <FormattedMessage id="groupInfoAbout.title.text" />
            </Heading>
            <Spacer size={props.spacerSize} />
          </>
        )
      }

      <I18nText data={group.about.get()}>
        {
          (txt) => (
            <div className="font-caption">
              <ClampedText
                lines={4}
                defaultExpanded={isWide}
                moreClassName="theme-group accent color"
              >
                {txt ? <GroupThemeMarkdown text={txt} /> : <br />}

                {props.additionalContent}
              </ClampedText>
            </div>
          )
        }
      </I18nText>
    </div>
  );
};
GroupAboutText.propTypes = {
  groupId: PropTypes.number,
  getGroup: PropTypes.func,
  preferredLanguage: PropTypes.string,
  additionalContent: PropTypes.any,
  defaultExpanded: PropTypes.bool,
  backgroundColor: PropTypes.string,
  noHeading: PropTypes.bool,
  hasTopPadding: PropTypes.bool,
  spacerSize: PropTypes.string,
};
GroupAboutText.defaultProps = {
  backgroundColor: 'white',
  spacerSize: '10',
};

export default connect(mapStateToProps)(GroupAboutText);
